import Container from 'components/Layout/Container'
import PageFullWidth from 'components/Layout/PageFullWidth'

// component
import { GetDataFAQ } from 'state/FAQ'
import Banner from './component/Banner'
import UserManual from './component/UserManual'
import SuggestMobile from './component/component/SuggestMobile'
import { CustomContaiFAQ } from './styled'

const FAQ = () => {
    const { isShowSuggest } = GetDataFAQ()
    return (
        <>
            <SuggestMobile />
            <CustomContaiFAQ isShowSuggest={isShowSuggest}>
                <Banner />
                <PageFullWidth>
                    <Container width="100%" mb="4rem" mt="2rem">
                        <UserManual />
                    </Container>
                </PageFullWidth>
            </CustomContaiFAQ>
        </>
    )
}
export default FAQ
